import { Box, Card, Skeleton } from '@mui/material';

export const PreviousMarketsSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {[1, 2].map((group) => (
        <Box key={group}>
          {/* Date Header Skeleton */}
          <Skeleton variant="text" width={150} height={32} sx={{ mb: 2 }} />

          {/* Previous Markets Card Skeleton */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {[1, 2].map((item) => (
              <Card
                key={item}
                sx={{
                  borderRadius: 0.5,
                  p: 2,
                  bgcolor: 'background.paper',
                  border: '1px solid',
                  borderColor: 'divider',
                  boxShadow: 'none',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                }}
              >
                {/* Header Row: Final Badge, Volume and Game View Button */}
                <Box
                  sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    {/* Final Badge Skeleton */}
                    <Skeleton variant="rounded" width={60} height={24} sx={{ borderRadius: 1 }} />
                    {/* Volume Skeleton */}
                    <Skeleton variant="text" width={70} height={16} />
                  </Box>
                  {/* Game View Button Skeleton */}
                  <Skeleton variant="rounded" width={120} height={32} sx={{ borderRadius: 5 }} />
                </Box>

                {/* Team Info Rows */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  {[1, 2].map((team) => (
                    <Box
                      key={team}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                      }}
                    >
                      {/* Score Skeleton */}
                      <Skeleton variant="rounded" width={22} height={22} sx={{ borderRadius: 1 }} />
                      {/* Logo Skeleton */}
                      <Skeleton variant="rounded" width={32} height={32} sx={{ borderRadius: 1 }} />
                      {/* Name Skeleton */}
                      <Skeleton variant="text" width={140} height={24} />
                      {/* Record Skeleton */}
                      <Skeleton variant="text" width={45} height={20} sx={{ ml: 'auto' }} />
                    </Box>
                  ))}
                </Box>
              </Card>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
